module.exports = __webpack_public_path__ + "img/bg2.d772114e.jpg";